<template>
  <div>
    <el-input class="search-el" size="mini" v-model="query.name" placeholder="请输入老师名称"></el-input>
    <el-input class="search-el" size="mini" v-model="query.order_no" placeholder="请输入订单编号"></el-input>
    <el-date-picker v-model="query.start_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="开始日期"></el-date-picker>~
    <el-date-picker v-model="query.end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="结束日期"></el-date-picker>
    <el-button type="primary" size="mini" @click="getListQuery()" style="margin-left: 20px;">
      查询
    </el-button>
    <el-button type="primary" size="mini" @click="deriveHandel()" style="margin-left: 20px;">
      导出
    </el-button>
    <el-row>
      <el-table
          v-loading="loading"
          :data="list"
          border
          size="mini"
          :stripe="true"
          style="width: 100%; margin: 20px 0"
      >
        <el-table-column prop="id" label="ID" align="center" min-width="5%"></el-table-column>
        <el-table-column prop="order_no" label="订单编号" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="name" label="老师名称" align="center" min-width="12%"></el-table-column>
        <el-table-column prop="type" label="类型" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="total_amount" label="订单价格" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="created_at" label="支付时间" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="counsel_time" label="本次咨询起止时间" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="settlement_base" label="本次结算基数(按次结算)" align="center" min-width="10%"></el-table-column>
        <el-table-column prop="settlement_ratio" label="结算比例" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="settlement_amount" label="结算金额" align="center" min-width="8%"></el-table-column>
        <el-table-column prop="settlement_at" label="结算时间" align="center" min-width="10%"></el-table-column>
<!--        <el-table-column prop="balance" label="账户余额" align="center" min-width="8%"></el-table-column>-->
        <el-table-column label="咨询日志" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small"
                       @click="row.service_log_id == 0 ? counselLogList(row.id) : counselLogInfo(row.service_log_id)">查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="refund_notes" label="备注" align="center" min-width="6%"></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
            background
            @current-change="getList"
            :current-page.sync="query.page"
            :page-size="query.limit"
            layout="total, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
        title="咨询日志"
        :visible.sync="counselLog.chooseOrgVisible"
        :close-on-click-modal="true"
        :before-close="counselLogUseFormOnClose"
        width="80%"
    >
      <!--列表-->
      <el-table
          border
          :data="counselLog.result.data"
          highlight-current-row
          v-loading="counselLog.listLoading1"
      >
        <el-table-column prop="counsel_time" label="咨询时间" align="center" min-width="65%"></el-table-column>
        <el-table-column label="操作" align="center" min-width="35%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small"
                       @click="counselLogInfo(row.id)">查看咨询日志
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="counselLogList"
          :current-page.sync="counselLog.query.page"
          :page-size="counselLog.query.limit"
          layout="total, prev, pager, next, jumper"
          :total="counselLog.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog title="咨询日志详情" :visible.sync="settlement.chooseOrgVisible" width="35%">
      <div v-if="settlement.result.data != null">
        <ul v-for="(item, index) in settlement.result.data" :key="index">
          <div>{{ index + 1 }}、{{ item.title }}</div>
          <li v-for="(i, d) in item.child" :key="d">{{ i.title }}:{{ i.value }}</li>
        </ul>
      </div>
      <div v-else>
        <span>咨询日志未填写</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getList, showCounselLogList, showCounselLogInfo} from "@/api/psySettlements";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        name: "",
        order_no: "",
        start_at: "",
        end_at: "",
      },
      counselLog: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          page: 1,
          psy_settlement_id: 0,
        },
        result: {
          total: 0,
          data: [],
        },
      },
      settlement: {
        chooseOrgVisible: false,
        query: {
          service_log_id: 0,
        },
        result: {
          data: [],
        },
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getListQuery(){
      this.query.page = 1
      this.getList()
    },

    getList() {
      this.loading = true;
      getList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    // 弹窗关闭
    counselLogUseFormOnClose() {
      this.counselLog.query.page = 1;
      this.counselLog.result = {
        total: 0,
        data: [],
      };
      this.counselLog.chooseOrgVisible = false;
      this.getList()
    },
    counselLogList(id) {
      this.counselLog.chooseOrgVisible = true
      this.counselLog.query.psy_settlement_id = id;
      this.counselLog.listLoading1 = true;
      showCounselLogList(this.counselLog.query).then((response) => {
        this.counselLog.result.data = response.data.list;
        this.counselLog.result.total = response.data.total;
        this.counselLog.listLoading1 = false;
      });
    },

    // 弹窗关闭
    settlementFormOnClose() {
      this.settlement.chooseOrgVisible = false;
      this.settlement.query.service_log_id = 0;
      this.getList()
    },
    counselLogInfo(service_log_id){
      this.settlement.chooseOrgVisible = true
      this.settlement.query.service_log_id = service_log_id;
      showCounselLogInfo(this.settlement.query).then((response) => {
        this.settlement.result.data = response.data;
      });
    },
    deriveHandel() { // 导出
      let option = {
        name: this.query.name,
        order_no: this.query.order_no,
        start_at: this.query.start_at,
        end_at:this.query.end_at
      }
      let url = 'https://backend.zhangdefenspace.com/backend/psy/settlement/export-list?';
        if (this.query.name != '') {
          url += `name=${this.query.name}&`;
        }
        if (this.query.order_no != '') {
          url += `order_no=${this.query.order_no}&`;
        }
        if (this.query.start_at != '') {
          url += `start_at=${this.query.start_at}&`;
        }
        if(this.query.end_at != ''){
          url += `end_at=${this.query.end_at}`;
        }

        // 移除最后一个字符（可能是 '&'）
        // url = url.slice(0, -1);

        // 跳转
        location.href = url;
        console.log(url,'url');
    },

  },
  mounted() {

  },
};
</script>